import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/plus-active.svg'


const _hoisted_1 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400 font-montserrat" }
const _hoisted_2 = { class: "flex flex-row my-4" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 text-black-lp-200" }
const _hoisted_4 = { class: "inline-flex" }
const _hoisted_5 = {
  ref: "formAddPos",
  class: "w-full px-4 text-12px xxl:text-14px overflow-y-auto pb-20 mt-6"
}
const _hoisted_6 = { class: "w-14/20" }
const _hoisted_7 = { class: "grid grid-cols-2 mt-4 gap-6" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = {
  key: 0,
  class: "w-full"
}
const _hoisted_10 = { class: "flex flex-row mt-4" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "flex flex-row mt-4" }
const _hoisted_13 = { class: "w-2/4 mr-6" }
const _hoisted_14 = {
  key: 0,
  class: "w-2/4"
}
const _hoisted_15 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_16 = { class: "ml-1 relative" }
const _hoisted_17 = {
  key: 1,
  class: "w-2/4"
}
const _hoisted_18 = {
  key: 0,
  class: "flex flex-row mt-4"
}
const _hoisted_19 = { class: "w-2/4 mr-6" }
const _hoisted_20 = { class: "w-2/4" }
const _hoisted_21 = {
  key: 1,
  class: "flex flex-row mt-4"
}
const _hoisted_22 = { class: "w-2/4 mr-6" }
const _hoisted_23 = { class: "w-2/4" }
const _hoisted_24 = {
  key: 2,
  class: "flex flex-row mt-4"
}
const _hoisted_25 = { class: "w-2/4 mr-6" }
const _hoisted_26 = { class: "w-2/4" }
const _hoisted_27 = { class: "flex flex-row mt-4" }
const _hoisted_28 = { class: "w-2/4 mr-6" }
const _hoisted_29 = { class: "w-2/4" }
const _hoisted_30 = {
  key: 3,
  class: "flex flex-row mt-4"
}
const _hoisted_31 = { class: "w-2/4 mr-6" }
const _hoisted_32 = {
  key: 0,
  class: "w-2/4"
}
const _hoisted_33 = {
  key: 1,
  class: "w-2/4"
}
const _hoisted_34 = {
  key: 4,
  class: "flex flex-row mt-4"
}
const _hoisted_35 = { class: "w-2/4 mr-6" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "w-2/4" }, null, -1)
const _hoisted_37 = { class: "w-2/4" }
const _hoisted_38 = {
  key: 5,
  class: "flex flex-row mt-4 relative"
}
const _hoisted_39 = {
  key: 6,
  class: "flex flex-row mt-4 relative"
}
const _hoisted_40 = {
  key: 7,
  class: "flex flex-row mt-4 relative"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_42 = {
  key: 9,
  class: "border-t my-6 border-gray-lp-400"
}
const _hoisted_43 = { class: "flex flex-row mt-4" }
const _hoisted_44 = { class: "w-2/4 mr-6" }
const _hoisted_45 = { class: "w-2/4" }
const _hoisted_46 = { class: "flex flex-row mt-4" }
const _hoisted_47 = { class: "w-2/4 mr-6" }
const _hoisted_48 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "plus"
}, null, -1)
const _hoisted_49 = { class: "w-2/4" }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "img-close-icon" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_52 = { class: "text-12px text-gray-lp-500 w-8/12 my-2" }
const _hoisted_53 = { class: "flex flex-row mt-4" }
const _hoisted_54 = { class: "w-2/4 mr-6" }
const _hoisted_55 = { class: "w-2/4" }
const _hoisted_56 = {
  key: 10,
  class: "flex flex-row mt-4"
}
const _hoisted_57 = { class: "w-12/12" }
const _hoisted_58 = { key: 11 }
const _hoisted_59 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_60 = { class: "flex flex-row mt-4" }
const _hoisted_61 = { class: "w-2/4 mr-6" }
const _hoisted_62 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_63 = { class: "grid gap-y-8 text-black-lp-300" }
const _hoisted_64 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_65 = {
  key: 0,
  class: "w-28"
}
const _hoisted_66 = { class: "flex-grow" }
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" a.n ")
const _hoisted_68 = { class: "font-semibold" }
const _hoisted_69 = { style: {"width":"86px"} }
const _hoisted_70 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_71 = { class: "grid gap-y-8 text-black-lp-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Select = _resolveComponent("Select")!
  const _component_CheckboxV2 = _resolveComponent("CheckboxV2")!
  const _component_SectionAreaDelivery = _resolveComponent("SectionAreaDelivery")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FileAttachment = _resolveComponent("FileAttachment")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalAddBank = _resolveComponent("ModalAddBank")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("img", {
          src: _imports_0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
          class: "w-5 mr-3 cursor-pointer",
          alt: "back"
        }),
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.getTitle), 1)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_button_fill, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createConfirmation())),
          isDisabled: _ctx.isFormValid,
          title: _ctx.$t('Simpan'),
          class: "bg-red-lp-300 px-8"
        }, null, 8, ["isDisabled", "title"])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_Title, {
          label: _ctx.$t('partnerManagement.route.detailPartner')
        }, null, 8, ["label"]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_DataWrapper, { label: _ctx.partnerName }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.consolidatorName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.consolidatorName = $event)),
                  placeholder: _ctx.$t('partnerManagement.route.changePartnerName')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          (_ctx.formType !== 'pos')
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('partnerManagement.route.posReturnStt'),
                  tooltipDescription: _ctx.$t('partnerManagement.route.posReturnSttDesc'),
                  optional: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectSearch, {
                      options: _ctx.posReverseJourney,
                      onFilter: _ctx.filterPartnerPosReverseJourney,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: _ctx.$t('partnerManagement.route.choosePosName'),
                      modelValue: _ctx.form.partnerPosReverseJourney,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.partnerPosReverseJourney = $event)),
                      isLoading: _ctx.isLoadingParentPos,
                      class: "my-2",
                      isDisabled: !_ctx.form.districts
                    }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "isLoading", "isDisabled"])
                  ]),
                  _: 1
                }, 8, ["label", "tooltipDescription"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('partnerManagement.route.address')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.consolidatorAddress,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.consolidatorAddress = $event)),
                  type: "textarea",
                  placeholder: _ctx.$t('partnerManagement.route.partnerAddress')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('partnerManagement.list.kecamatanKota')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectSearch, {
                  "is-show-error-indicator": _ctx.errorKecamatanKota,
                  "error-caption": _ctx.errorCaptionKecamatanKota,
                  options: _ctx.districts,
                  onFilter: _ctx.fetchDistricts,
                  isLoading: _ctx.isLoadingDistricts,
                  keyName: "name",
                  keyValue: "id",
                  placeholder: _ctx.$t('partnerManagement.list.enterLocation'),
                  modelValue: _ctx.form.districts,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.districts = $event)),
                  onChange: _ctx.getConsolidatorsByCity,
                  class: "my-2",
                  onClose: _ctx.onCloseSelectConsolidatorsByCity,
                  "data-testid": "partner-add-district-select"
                }, null, 8, ["is-show-error-indicator", "error-caption", "options", "onFilter", "isLoading", "placeholder", "modelValue", "onChange", "onClose"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          (_ctx.formType === 'consolidator')
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("p", null, _toDisplayString(_ctx.$t('partnerManagement.list.additionalCity')), 1),
                  _createVNode("div", _hoisted_16, [
                    _createVNode("img", {
                      onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isOpenTooltipAddCity = true)),
                      onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isOpenTooltipAddCity = false)),
                      src: 
                  _ctx.isOpenTooltipAddCity
                    ? require('@/app/ui/assets/svg/info-red.svg')
                    : require('@/app/ui/assets/svg/info.svg')
                ,
                      alt: ""
                    }, null, 40, ["src"]),
                    _withDirectives(_createVNode(_component_Tooltip, {
                      title: _ctx.$t('partnerManagement.list.additionalCity'),
                      message: _ctx.$t('partnerManagement.list.additionalCityDesc'),
                      footer: "",
                      style: {"width":"280px","margin-left":"2.6em","margin-top":"-2.6em"}
                    }, null, 8, ["title", "message"]), [
                      [_vShow, _ctx.isOpenTooltipAddCity]
                    ])
                  ])
                ]),
                _createVNode(_component_MultipleSelectSearch, {
                  options: _ctx.cityListData,
                  onFilter: _ctx.filterCityList,
                  modelValue: _ctx.form.cityExclude,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.cityExclude = $event)),
                  error: _ctx.cityOver,
                  errorCaption: _ctx.$t('partnerManagement.list.maxAdditionalCity'),
                  keyName: "name",
                  keyValue: "code",
                  placeholder: _ctx.$t('partnerManagement.list.enterCity')
                }, null, 8, ["options", "onFilter", "modelValue", "error", "errorCaption", "placeholder"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.formType === 'pos')
            ? (_openBlock(), _createBlock("div", _hoisted_17))
            : _createCommentVNode("", true)
        ]),
        (_ctx.formType === 'sub-consolidator')
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('partnerManagement.list.consoleName'),
                  optional: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectSearch, {
                      options: _ctx.consolidatorsWithouCityCode,
                      onFilter: _ctx.filterConsolidatorsWithoutCode,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: _ctx.$t('partnerManagement.list.consoleName'),
                      modelValue: _ctx.form.subconsolidators,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.subconsolidators = $event)),
                      isLoading: _ctx.isLoadingConsolidators,
                      class: "my-2",
                      onClose: _ctx.onCloseSelectSearchConsolidatorWithoutCode
                    }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "isLoading", "onClose"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('partnerManagement.list.namaPartnerArea')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectSearch, {
                      options: _ctx.consolidators,
                      onFilter: _ctx.filterConsolidators,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: _ctx.$t('partnerManagement.list.enterPartner'),
                      modelValue: _ctx.form.consolidators,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.consolidators = $event)),
                      isLoading: _ctx.isLoadingConsolidators,
                      class: "my-2",
                      onClose: _ctx.onCloseSelectSearchConsolidator
                    }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "isLoading", "onClose"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.formType === 'consolidator')
          ? (_openBlock(), _createBlock("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('partnerManagement.detail.phone')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      prefix: _ctx.districtFieldRules.phoneDialCode,
                      debounce: 500,
                      format: _ctx.formatNumber,
                      modelValue: _ctx.form.phone,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.phone = $event)),
                      error: _ctx.error.phone,
                      onChange: _ctx.validatePhone,
                      errorCaption: "Masukan No. Telepon dengan benar",
                      maxLength: "13",
                      placeholder: "e.g 2112341234",
                      "data-testid": "partner-add-partner-phone"
                    }, null, 8, ["prefix", "format", "modelValue", "error", "onChange"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createVNode("div", _hoisted_23, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('partnerManagement.list.tax')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.form.taxNumber,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.taxNumber = $event)),
                      format: _ctx.formatTax,
                      onChange: _ctx.validateTaxNumber,
                      errorCaption: _ctx.$t('partnerManagement.list.enterTax'),
                      error: _ctx.error.taxNumber,
                      placeholder: _ctx.taxPlaceholder,
                      maxLength: _ctx.taxMaxLength,
                      "show-max-length": "",
                      "data-testid": "partner-add-tax-number"
                    }, null, 8, ["modelValue", "format", "onChange", "errorCaption", "error", "placeholder", "maxLength"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.formType === 'pos')
          ? (_openBlock(), _createBlock("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('partnerManagement.list.partnerType')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Select, {
                      onOpenSelect: _ctx.onOpenSelectPartnerType,
                      onCloseSelect: _ctx.onCloseSelectPartnerType,
                      isOpenMenu: _ctx.isOpenPartnerType,
                      value: _ctx.form.partnerArea,
                      onChooseSelect: _ctx.onSelectPartnerType,
                      dataSelect: _ctx.partnerAreaTypeList,
                      class: "w-full whitespace-no-wrap my-2 z-10"
                    }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createVNode("div", _hoisted_26, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('partnerManagement.list.namaPartnerArea')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectSearch, {
                      options: _ctx.consolidators,
                      onFilter: _ctx.filterConsolidators,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: _ctx.$t('partnerManagement.list.enterPartner'),
                      modelValue: _ctx.form.consolidators,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.consolidators = $event)),
                      isLoading: _ctx.isLoadingConsolidators,
                      class: "my-2"
                    }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "isLoading"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            _createVNode(_component_DataWrapper, { label: "Latitude" }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  placeholder: _ctx.$t('partnerManagement.list.enterLatitude'),
                  modelValue: _ctx.form.latitude,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.latitude = $event)),
                  format: _ctx.formatLongLat
                }, null, 8, ["placeholder", "modelValue", "format"])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_29, [
            _createVNode(_component_DataWrapper, { label: "Longitude" }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  placeholder: _ctx.$t('partnerManagement.list.enterLongtitude'),
                  modelValue: _ctx.form.longitude,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.longitude = $event)),
                  format: _ctx.formatLongLat
                }, null, 8, ["placeholder", "modelValue", "format"])
              ]),
              _: 1
            })
          ])
        ]),
        (_ctx.formType === 'pos')
          ? (_openBlock(), _createBlock("div", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('partnerManagement.list.tipePos')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Select, {
                      class: "w-full my-2",
                      dataSelect: _ctx.typePos,
                      onOpenSelect: () => (_ctx.openTypePos = true),
                      onCloseSelect: () => (_ctx.openTypePos = false),
                      onChooseSelect: _ctx.onChangeTypePos,
                      value: _ctx.form.typePos,
                      isOpenMenu: _ctx.openTypePos
                    }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              (_ctx.form.typePos === 'branch' || _ctx.form.typePos === 'pickup')
                ? (_openBlock(), _createBlock("div", _hoisted_32, [
                    _createVNode(_component_DataWrapper, { label: "POS Parent" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SelectSearch, {
                          options: _ctx.parentPos,
                          onFilter: _ctx.filterParentPos,
                          keyName: "name",
                          keyValue: "id",
                          placeholder: _ctx.$t('partnerManagement.list.choosePosParent'),
                          modelValue: _ctx.form.parentPos,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.parentPos = $event)),
                          isLoading: _ctx.isLoadingParentPos,
                          class: "my-2",
                          isDisabled: !_ctx.form.districts,
                          onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.filterParentPos('')))
                        }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "isLoading", "isDisabled"])
                      ]),
                      _: 1
                    })
                  ]))
                : (_ctx.form.typePos === 'parent' || !_ctx.form.typePos)
                  ? (_openBlock(), _createBlock("div", _hoisted_33, [
                      _createVNode(_component_DataWrapper, {
                        label: _ctx.$t('partnerManagement.list.posOwnerName'),
                        optional: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SelectSearch, {
                            options: _ctx.consolidatorConsolePos,
                            onFilter: _ctx.filterSubconsolidators,
                            keyName: "name",
                            keyValue: "id",
                            placeholder: _ctx.$t('partnerManagement.list.typePosOwner'),
                            modelValue: _ctx.form.subconsolidators,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.form.subconsolidators = $event)),
                            isLoading: _ctx.isLoadingConsolidators,
                            class: "my-2"
                          }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "isLoading"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.formType === 'pos' && _ctx.form.typePos !== 'parent' && _ctx.form.typePos)
          ? (_openBlock(), _createBlock("div", _hoisted_34, [
              _createVNode("div", _hoisted_35, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('partnerManagement.list.posOwnerName'),
                  optional: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectSearch, {
                      options: _ctx.consolidatorConsolePos,
                      onFilter: _ctx.filterSubconsolidators,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: _ctx.$t('partnerManagement.list.typePosOwner'),
                      modelValue: _ctx.form.subconsolidators,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.form.subconsolidators = $event)),
                      isLoading: _ctx.isLoadingConsolidators,
                      class: "my-2"
                    }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "isLoading"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _hoisted_36
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_37, [
          _withDirectives(_createVNode(_component_DataWrapper, {
            label: _ctx.$t('partnerManagement.list.posCommition')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                placeholder: _ctx.$t('partnerManagement.list.enterPosCommition'),
                modelValue: _ctx.form.branchCommission,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.form.branchCommission = $event)),
                format: _ctx.formatCommission,
                error: _ctx.error.commision,
                onChange: _ctx.validateCommision,
                errorCaption: _ctx.errorCaptionCommision,
                min: "0",
                max: "100",
                suffix: "%"
              }, null, 8, ["placeholder", "modelValue", "format", "error", "onChange", "errorCaption"])
            ]),
            _: 1
          }, 8, ["label"]), [
            [_vShow, false]
          ])
        ]),
        (_ctx.formType === 'pos')
          ? (_openBlock(), _createBlock("div", _hoisted_38, [
              _createVNode(_component_CheckboxV2, {
                label: "COD Delivery Partner",
                class: "w-2/4",
                hint: `${_ctx.$t('partnerManagement.list.optional')}`,
                textSize: 14,
                keyName: "CODDeliveryPartnerAdd",
                value: _ctx.form.partnerIsCodDelivery,
                "onUpdate:value": _ctx.onCheckedCODDeliveryPartner
              }, null, 8, ["hint", "value", "onUpdate:value"]),
              _createVNode(_component_CheckboxV2, {
                label: "COD Booking Partner",
                hint: `${_ctx.$t('partnerManagement.list.optional')}`,
                textSize: 14,
                keyName: "CODBookingPartnerAdd",
                value: _ctx.form.partnerIsCodBooking,
                "onUpdate:value": _ctx.onCheckedCODBookingPartner
              }, null, 8, ["hint", "value", "onUpdate:value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.formType === 'pos')
          ? (_openBlock(), _createBlock("div", _hoisted_39, [
              _createVNode(_component_CheckboxV2, {
                label: "PCU",
                class: "w-2/4",
                hint: `${_ctx.$t('partnerManagement.list.optional')}`,
                textSize: 14,
                keyName: "PartnerIsPCU",
                value: _ctx.form.partnerIsPcu,
                "onUpdate:value": _ctx.onCheckedPartnerIsPCU
              }, null, 8, ["hint", "value", "onUpdate:value"]),
              _createVNode(_component_CheckboxV2, {
                label: "Booking VIPPACK",
                hint: `${_ctx.$t('partnerManagement.list.optional')}`,
                textSize: 14,
                keyName: "BookingVipPack",
                value: _ctx.form.partnerIsAllowBookVippack,
                "onUpdate:value": _ctx.onCheckedPartnerIsAllowBookVippack
              }, null, 8, ["hint", "value", "onUpdate:value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.formType === 'pos')
          ? (_openBlock(), _createBlock("div", _hoisted_40, [
              _createVNode(_component_CheckboxV2, {
                label: "POS Ownsales",
                class: "w-2/4",
                hint: `${_ctx.$t('partnerManagement.list.optional')}`,
                textSize: 14,
                keyName: "PartnerIsOwnsales",
                value: _ctx.form.partnerIsPosOwnSales,
                "onUpdate:value": _ctx.onCheckedPartnerIsPosOwnSales
              }, null, 8, ["hint", "value", "onUpdate:value"])
            ]))
          : _createCommentVNode("", true),
        _hoisted_41,
        (_ctx.formType === 'consolidator' && _ctx.isShowAreaDeliverySection)
          ? (_openBlock(), _createBlock(_component_SectionAreaDelivery, {
              key: 8,
              form: _ctx.form
            }, null, 8, ["form"]))
          : _createCommentVNode("", true),
        (_ctx.formType === 'consolidator' && _ctx.isShowAreaDeliverySection)
          ? (_openBlock(), _createBlock("div", _hoisted_42))
          : _createCommentVNode("", true),
        _createVNode(_component_Title, {
          label: _ctx.$t('partnerManagement.detail.contactInfo')
        }, null, 8, ["label"]),
        _createVNode("div", _hoisted_43, [
          _createVNode("div", _hoisted_44, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('partnerManagement.list.name')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.contactName,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.form.contactName = $event)),
                  placeholder: _ctx.$t('partnerManagement.list.enterName')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_45, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('partnerManagement.list.position')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.contactLevel,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.form.contactLevel = $event)),
                  placeholder: _ctx.$t('partnerManagement.list.enterPosition')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createVNode("div", _hoisted_46, [
          _createVNode("div", _hoisted_47, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.contactPhones, (phone, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('partnerManagement.detail.phone'),
                  class: index > 0 ? `my-4` : ``
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      prefix: _ctx.districtFieldRules.phoneDialCode,
                      debounce: 500,
                      format: _ctx.formatNumber,
                      modelValue: phone.no,
                      "onUpdate:modelValue": ($event: any) => (phone.no = $event),
                      error: phone.error,
                      onChange: ($event: any) => (_ctx.validateContactPhone(index)),
                      errorCaption: "Masukan No. Telepon dengan benar",
                      "data-testid": index === 0 ? 'partner-add-contact-phone-0' : null,
                      maxLength: "13",
                      placeholder: "e.g 2112341234",
                      onSetPhone: (e) => _ctx.setContactPhoneNumber(e, index),
                      onSetPhoneCode: (e) => _ctx.setContactPhoneCodeNumber(e, index)
                    }, null, 8, ["prefix", "format", "modelValue", "onUpdate:modelValue", "error", "onChange", "data-testid", "onSetPhone", "onSetPhoneCode"])
                  ]),
                  _: 2
                }, 1032, ["label", "class"])
              ]))
            }), 128)),
            (_ctx.isMaxContactPhone)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.addPhone && _ctx.addPhone(...args))),
                  class: "cursor-pointer flex gap-3 text-red-lp-300 my-4"
                }, [
                  _hoisted_48,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('partnerManagement.list.addPhone')), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_49, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.contactPhones, (phone, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                (index === 0)
                  ? (_openBlock(), _createBlock(_component_DataWrapper, {
                      key: 0,
                      label: "Email"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lp_input, {
                          modelValue: _ctx.form.contactEmail,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.form.contactEmail = $event)),
                          onChange: _ctx.validateEmail,
                          errorCaption: _ctx.$t('partnerManagement.list.enterEmailError'),
                          error: _ctx.error.contactEmail,
                          placeholder: "e.g email@gmail.com"
                        }, null, 8, ["modelValue", "onChange", "errorCaption", "error"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (index > 0)
                  ? (_openBlock(), _createBlock("div", {
                      key: 1,
                      onClick: ($event: any) => (_ctx.removePhone(index)),
                      class: 
                `${
                  index === 1 ? 'close-gap-one' : 'close-gap-two'
                } self-center cursor-pointer relative`
              
                    }, [
                      _hoisted_50
                    ], 10, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _hoisted_51,
        _createVNode(_component_Title, { label: "Periode Kontrak" }),
        _createVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('partnerManagement.list.accountWillActive')), 1),
        _createVNode("div", _hoisted_53, [
          _createVNode("div", _hoisted_54, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('partnerManagement.list.startFrom')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DatePicker, {
                  class: "my-2",
                  modelValue: _ctx.form.startDate,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.form.startDate = $event)),
                  maxDate: new Date()
                }, null, 8, ["modelValue", "maxDate"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_55, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('partnerManagement.list.until')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DatePicker, {
                  class: "my-2",
                  modelValue: _ctx.form.endDate,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.form.endDate = $event)),
                  minDate: new Date(new Date().setDate(new Date().getDate() + 1))
                }, null, 8, ["modelValue", "minDate"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        (_ctx.isFormTypePos)
          ? (_openBlock(), _createBlock("div", _hoisted_56, [
              _createVNode("div", _hoisted_57, [
                _createVNode(_component_FileAttachment, {
                  onUpdateFiles: _ctx.updateFiles,
                  onSetLoadingUpload: _ctx.setLoadingUpload
                }, null, 8, ["onUpdateFiles", "onSetLoadingUpload"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isFormTypePos)
          ? (_openBlock(), _createBlock("div", _hoisted_58, [
              _hoisted_59,
              _createVNode(_component_Title, {
                label: _ctx.$t('partnerManagement.detail.additionalInfo')
              }, null, 8, ["label"]),
              _createVNode("div", _hoisted_60, [
                _createVNode("div", _hoisted_61, [
                  _createVNode(_component_DataWrapper, {
                    label: "Saldo Deposit",
                    "data-testid": "partner-add-currency-prefix"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        modelValue: _ctx.form.debitBalance,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.form.debitBalance = $event)),
                        prefix: _ctx.districtFieldRules.currencyLabel,
                        format: _ctx.formatDebitBalance,
                        placeholder: _ctx.$t('partnerManagement.detail.additionalInfo'),
                        "data-testid": "partner-add-debit-balance"
                      }, null, 8, ["modelValue", "prefix", "format", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_62,
        _createVNode("div", _hoisted_63, [
          _createVNode(_component_Title, {
            label: _ctx.$t('partnerManagement.detail.bankInfo'),
            hint: _ctx.$t('partnerManagement.list.optional')
          }, null, 8, ["label", "hint"]),
          (_ctx.form.bank.accountName)
            ? (_openBlock(), _createBlock("div", _hoisted_64, [
                (_ctx.form.bank.bankLogo)
                  ? (_openBlock(), _createBlock("div", _hoisted_65, [
                      _createVNode("img", {
                        src: _ctx.form.bank.bankLogo,
                        class: "w-28",
                        alt: "bank_logo"
                      }, null, 8, ["src"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_66, [
                  _createVNode("p", null, _toDisplayString(_ctx.form.bank.bankName), 1),
                  _createVNode("p", null, _toDisplayString(_ctx.form.bank.accountNo), 1),
                  _createVNode("p", null, [
                    _hoisted_67,
                    _createVNode("span", _hoisted_68, _toDisplayString(_ctx.form.bank.accountName), 1)
                  ]),
                  _createVNode("p", null, _toDisplayString(_ctx.form.bank.accountEmail), 1)
                ]),
                _createVNode("div", _hoisted_69, [
                  (_ctx.showAddOrDeleteBankAccountButton)
                    ? (_openBlock(), _createBlock(_component_button_fill, {
                        key: 0,
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.onDeleteBank())),
                        title: "Hapus",
                        class: "text-red-lp-300 px-8",
                        style: {"background-color":"white"}
                      }))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('partnerManagement.list.noBank')), 1),
                (_ctx.showAddOrDeleteBankAccountButton)
                  ? (_openBlock(), _createBlock(_component_button_fill, {
                      key: 0,
                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.onShowAddBank(true))),
                      title: _ctx.$t('partnerManagement.list.addAccount'),
                      class: "bg-red-lp-300 px-8",
                      style: {"width":"237px"}
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true)
              ], 64))
        ]),
        (_ctx.formType === 'pos')
          ? (_openBlock(), _createBlock(_Fragment, { key: 12 }, [
              _hoisted_70,
              _createVNode("div", _hoisted_71, [
                _createVNode(_component_Title, {
                  label: _ctx.$t('partnerManagement.list.referral'),
                  hint: _ctx.$t('partnerManagement.list.optional')
                }, null, 8, ["label", "hint"]),
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: "Kode Referral"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_LpInput, {
                      class: "my-2",
                      modelValue: _ctx.form.referralCode,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.form.referralCode = $event)),
                      onChange: _ctx.onChangeReferralCode,
                      placeholder: _ctx.$t('partnerManagement.list.enterReferral'),
                      error: !_ctx.validateReferralCode,
                      errorCaption: _ctx.$t('partnerManagement.list.referralNotFound')
                    }, null, 8, ["modelValue", "onChange", "placeholder", "error", "errorCaption"])
                  ]),
                  _: 1
                })
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ], 512),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCreate,
      onClose: _ctx.onCloseConfirmation,
      title: _ctx.$t('partnerManagement.list.confirmCreation'),
      message: 
      `${_ctx.$t('partnerManagement.list.areUsure')} “${_ctx.form.consolidatorName}”?`
    ,
      image: "are-you-sure",
      textSuccess: _ctx.$t('Simpan'),
      textCancel: _ctx.$t('Kembali'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmation]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: _ctx.$t('Pembuatan Berhasil !'),
      message: `Partner “${_ctx.form.consolidatorName}” ${_ctx.$t('partnerManagement.list.success')}.`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message"]), [
      [_vShow, _ctx.openSuccess || _ctx.openSuccessFromState]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('Yakin ingin keluar?'),
      message: _ctx.$t('Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('Keluar'),
      textCancel: _ctx.$t('Kembali'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    (_ctx.showAddBank)
      ? (_openBlock(), _createBlock(_component_ModalAddBank, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}